var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconFee(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5938 3.875C14.4219 3.875 13.3311 4.22166 12.4218 4.82166C12.5405 4.81541 12.6594 4.8125 12.7812 4.8125C16.6656 4.8125 19.8125 7.95937 19.8125 11.8438C19.8125 12.5656 19.7031 13.2591 19.5031 13.9122C20.6531 12.8591 21.375 11.3406 21.375 9.65625C21.375 6.4625 18.7875 3.875 15.5938 3.875ZM12.3125 5.4375C11.0719 5.4375 9.91584 5.80005 8.94397 6.42505C9.22834 6.39067 9.51875 6.375 9.8125 6.375C13.9531 6.375 17.3125 9.73438 17.3125 13.875C17.3125 14.5125 17.2312 15.1344 17.0812 15.725C18.0062 14.6375 18.5625 13.225 18.5625 11.6875C18.5625 8.23438 15.7656 5.4375 12.3125 5.4375ZM9.5 7C5.87563 7 2.9375 9.93813 2.9375 13.5625C2.9375 17.1869 5.87563 20.125 9.5 20.125C13.1244 20.125 16.0625 17.1869 16.0625 13.5625C16.0625 9.93813 13.1244 7 9.5 7Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFee);
export default __webpack_public_path__ + "static/media/icon-fee.4b27d04318b5033e03b4532044978362.svg";
export { ForwardRef as ReactComponent };